import { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Breadcrumbs } from "@components";
import { HeaderUserMenu } from "./HeaderUserMenu";
import { headerStyle } from "./styles";

export const Header = () => {
  const theme = useTheme();
  const sidebarWidth = parseInt(theme.constants.SIDEBAR_WIDTH!, 10);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const rezise = () => {
      const width = `${document.documentElement.clientWidth - sidebarWidth - 24 * 2}px`;
      headerRef.current?.style.setProperty("width", width);
    };
    rezise();

    window.addEventListener("resize", rezise);

    return () => {
      window.removeEventListener("resize", rezise);
    };
  });
  return (
    <Box ref={headerRef} sx={headerStyle}>
      <Breadcrumbs />
      <HeaderUserMenu />
    </Box>
  );
};
